import { create } from "zustand";
import { devtools } from "zustand/middleware";

export type SidebarState = {
  isOpen: boolean;
  onInit(): void;
  openSidebar(): void;
  closeSidebar(): void;
  closeSidebarOnMobile(): void;
  toggleSidebar(): void;
};

const SIDEBAR_OPEN_KEY = "sidebar-open";

export const SidebarStore = create<SidebarState>()(
  devtools((set, getState) => ({
    isOpen: false,

    onInit: () => {
      if (!localStorage.getItem(SIDEBAR_OPEN_KEY)) {
        localStorage.setItem(SIDEBAR_OPEN_KEY, String(true));
      }

      set({ isOpen: localStorage.getItem(SIDEBAR_OPEN_KEY) === "true" });
    },

    openSidebar: () => {
      set({ isOpen: true });
      localStorage.setItem(SIDEBAR_OPEN_KEY, String(getState().isOpen));
    },

    closeSidebar: () => {
      set({ isOpen: false });
      localStorage.setItem(SIDEBAR_OPEN_KEY, String(getState().isOpen));
    },

    closeSidebarOnMobile: () => {
      if (!getState().isOpen) {
        return;
      }

      const minWidth = 992;

      if (window.innerWidth < minWidth) {
        getState().closeSidebar();
      }
    },

    toggleSidebar: () => {
      const isOpen = !getState().isOpen;
      set({ isOpen: isOpen });
      localStorage.setItem(SIDEBAR_OPEN_KEY, String(isOpen));
    },
  })),
);
